export function RequestFilterItem({
  label,
}: RequestFilterItemProps): JSX.Element {
  return (
    <div className="filter-item active">
      <span>{label}</span>
    </div>
  );
}
